import { render, staticRenderFns } from "./NoticiasMercadoNovosCursos.vue?vue&type=template&id=1c765cf2&"
import script from "./NoticiasMercadoNovosCursos.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoNovosCursos.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoNovosCursos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports